var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.resolvedComponent,{tag:"component",attrs:{"data":_vm.slide.visual || {},"config":_vm.config,"progress":_vm.progress}})
}
var staticRenderFns = []

export { render, staticRenderFns }